import { useTranslation } from 'react-i18next';
import { LuBell } from 'react-icons/lu';

export const NotificationsEmptyState = () => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col items-center gap-2.5 py-4">
            <div className="flex items-center justify-center size-[50px] rounded-full bg-surface-light">
                <LuBell className="text-2xl text-midnight" />
            </div>
            <span className="text-sm font-bold text-midnight text-center">{t('TOP_HEADER.NOTIFICATIONS.TITLE')}</span>
            <span className="text-sm text-midnight text-center">{t('TOP_HEADER.NOTIFICATIONS.EMPTY')}</span>
        </div>
    );
};
